import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from '@/store/user/moduleUser.js'
import basicValues from '@/store/basicValues/moduleBasicValues.js'
import event from '@/store/event/moduleEvent.js'
import recherche from '@/store/recherche/moduleRecherche.js'
import fundings from '@/store/fundings/moduleFundings.js'
import template from '@/store/template/moduleTemplate.js'
import rechercheFilters from '@/store/rechercheFilters/moduleFilters.js'
import eventDashboard from '@/store/eventDashboard/moduleEventDashboard.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    basicValues,
    event,
    recherche,
    fundings,
    template,
    rechercheFilters,
    eventDashboard
  },
  plugins: [createPersistedState({
    paths: [
      'user.currentUser',
      'user.isAuthenticated',
      'user.mitarbeiterAddressID'
    ] // Path to state which should be persisted
  })]
})
